import * as React from "react";
import {
  TextField,
  BooleanField,
  Show,
  usePermissions,
  useRecordContext,
  Title,
  ImageField,
  SelectField,
  TopToolbar,
  EditButton,
  LinearProgress,
  Button,
  useRedirect,
  useNotify,
  useDataProvider,
  Confirm,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
  DateField,
} from "react-admin";
import { ROLE_TYPES } from "../enums/Roles";
import { SimpleShowLayout } from "../common/SimpleShowLayout";
import VideoField from "../common/VideoField";
import { VIDEO_TYPES } from "../enums/VideoTypes";
import { Delete } from "@mui/icons-material";

const VideoShowActions = () => {
  const dataProvider = useDataProvider();
  const redirect = useRedirect();
  const notify = useNotify();
  const { permissions } = usePermissions();
  const record = useRecordContext();
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);

  const onDeleteConfirm = () => {
    notify("Eliminando video...");
    setIsLoading(true);
    setDialogOpen(false);

    dataProvider
      .deleteVideo("videos", record.id)
      .then(({ data }) => {
        notify("Video eliminado con éxito", { type: "success" });
        redirect("list", "/videos");
      })
      .catch((error) => {
        notify("Ha ocurrido un error eliminado el video", {
          type: "error",
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  if (isLoading) return <LinearProgress />;

  return (
    <TopToolbar>
      <EditButton />
      {permissions === ROLE_TYPES.ADMIN && (
        <Button
          label="Eliminar"
          onClick={() => setDialogOpen(true)}
          color="error"
        >
          <Delete />
        </Button>
      )}
      <Confirm
        isOpen={dialogOpen}
        loading={false}
        title={`Eliminar video`}
        content="¿Estás seguro de eliminar este video?"
        onConfirm={onDeleteConfirm}
        onClose={() => setDialogOpen(false)}
      />
    </TopToolbar>
  );
};

const VideoTitle = () => {
  const record = useRecordContext();
  return <Title title={`Video "${record?.name}"`} />;
};

const VideoShow = () => {
  const { permissions } = usePermissions();
  return (
    <Show title={<VideoTitle />} actions={<VideoShowActions />}>
      <SimpleShowLayout>
        {permissions === ROLE_TYPES.ADMIN && (
          <TextField source="id" label="ID" />
        )}
        <TextField source="name" label="Nombre" />

        <VideoField source="originalURL" label="Video" />

        <ImageField source="thumbnail" label="Miniatura" />

        <SelectField
          label="Tipo"
          source="type"
          choices={[
            { id: VIDEO_TYPES.RESTAURANT, name: "Restaurante" },
            // { id: VIDEO_TYPES.PRODUCT, name: "Producto" },
          ]}
        />

        <ReferenceArrayField
          label="Restaurantes"
          reference="restaurants"
          source="restaurants"
          emptyText="-"
        >
          <SingleFieldList linkType="show">
            <ChipField source="name" />
          </SingleFieldList>
        </ReferenceArrayField>

        {/* <ReferenceArrayField
          label="Productos"
          reference="products"
          source="products"
          emptyText="-"
        >
          <SingleFieldList linkType="show">
            <ChipField source="name" />
          </SingleFieldList>
        </ReferenceArrayField> */}
        <DateField source="startDate" label="Fecha Inicio" showTime={true} />
        <DateField source="endDate" label="Fecha Fin" showTime={true} />
        <BooleanField source="active" label="Activo" />
      </SimpleShowLayout>
    </Show>
  );
};

export default VideoShow;
